import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { useSeo } from '../utils/useSeo';

const CONTACT_EMAIL = 'klinikvet.app@gmail.com';

const AccountDeletionPage: React.FC = () => {
  useSeo({
    title: 'Hesap Silme | KlinikVet',
    description: 'KlinikVet mobil uygulamasında hesabınızı nasıl silebileceğiniz, hangi verilerin silindiği ve hangilerinin saklandığı.',
    path: '/hesap-silme',
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold text-gray-900">
            <span className="w-8 h-8 rounded-lg bg-teal-700 flex items-center justify-center">
              <img src="/brand-symbol.png" alt="" className="h-5 w-auto" />
            </span>
            KlinikVet
          </Link>
          <Link to="/" className="text-sm text-gray-600 flex items-center gap-1">
            <ArrowLeft className="h-4 w-4" /> Ana sayfa
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Hesap silme</h1>
          <p className="text-gray-600">
            Bu sayfa, MSE Soft tarafından geliştirilen <strong>KlinikVet</strong> mobil uygulamasındaki hesabınızı
            nasıl silebileceğinizi, hangi verilerin silindiğini ve hangilerinin saklandığını anlatır.
          </p>
        </div>

        <section className="bg-white border border-gray-200 rounded-2xl p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Uygulama içinden silme (önerilen)</h2>
          <ol className="list-decimal pl-5 space-y-2 text-gray-700">
            <li>KlinikVet uygulamasını açın ve giriş yapın.</li>
            <li>Alttaki menüden <strong>Profil</strong> sekmesine dokunun.</li>
            <li><strong>Hesabı Sil</strong> satırına dokunun.</li>
            <li>Açılan pencerede <strong>Hesabımı Sil</strong> ile onaylayın.</li>
          </ol>
          <p className="text-gray-600 text-sm mt-3">İşlem anında tamamlanır ve geri alınamaz.</p>
        </section>

        <section className="bg-white border border-gray-200 rounded-2xl p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Uygulamaya erişemiyorsanız</h2>
          <p className="text-gray-700 mb-4">
            Aşağıdaki adrese, uygulamada kullandığınız e-posta adresinden "Hesap silme talebi" konulu bir e-posta gönderin.
            Talebinizi en geç 7 gün içinde işleriz.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}?subject=Hesap%20silme%20talebi`}
            className="inline-flex items-center gap-2 bg-teal-700 text-white px-5 py-3 rounded-xl font-medium"
          >
            <Mail className="h-5 w-5" /> {CONTACT_EMAIL}
          </a>
        </section>

        <section className="bg-white border border-gray-200 rounded-2xl p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Hangi veriler silinir?</h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-700">
            <li>Giriş hesabınız (e-posta ile oluşturulan kimlik doğrulama kaydı) kalıcı olarak silinir.</li>
            <li>Cihazınıza ait bildirim kayıtları silinir.</li>
            <li>Hesabınızın kliniğinizdeki kayıtla bağlantısı koparılır; aynı e-postayla uygulamaya tekrar giriş yapılamaz.</li>
          </ul>
        </section>

        <section className="bg-white border border-gray-200 rounded-2xl p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Hangi veriler saklanır ve ne kadar süre?</h2>
          <p className="text-gray-700">
            Ad, telefon, adres ve hayvanlarınıza ait muayene, aşı ve randevu kayıtları <strong>veteriner kliniğinizin
            yasal kayıtlarıdır</strong>. Bu kayıtlar, klinik veri sorumlusu olduğundan klinikte kalır ve kliniğin yasal
            saklama yükümlülükleri süresince tutulur. Bu kayıtların silinmesini doğrudan kliniğinizden talep edebilirsiniz.
            MSE Soft, hesap silindikten sonra kimlik doğrulama verilerinizi saklamaz.
          </p>
        </section>

        <p className="text-sm text-gray-500">
          <Link to="/gizlilik" className="underline">Gizlilik Politikası</Link> · <Link to="/kvkk" className="underline">KVKK Aydınlatma Metni</Link> · <Link to="/destek" className="underline">Destek</Link>
        </p>
      </main>
    </div>
  );
};

export default AccountDeletionPage;
